import { render, staticRenderFns } from "./modal-updated-proof-options.vue?vue&type=template&id=7a1c52bd&scoped=true&"
import script from "./modal-updated-proof-options.vue?vue&type=script&lang=js&"
export * from "./modal-updated-proof-options.vue?vue&type=script&lang=js&"
import style0 from "./modal-updated-proof-options.vue?vue&type=style&index=0&id=7a1c52bd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1c52bd",
  null
  
)

export default component.exports